import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AliasEditorComponent } from "../../../../components/common/alias-editor/alias-editor.component";
import { TrafficLineChart } from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.component";
import {
  TrafficSubject,
  makeAllServicesOption,
  makeNamedOption,
} from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.helpers";
import { PortServicesPanel } from "../../../../components/subscription-detail/port-services-panel/port-services-panel";
import { ServiceId } from "../../../../components/subscription-detail/service-id/service-id";
import { SubscriptionDetailHeader } from "../../../../components/subscription-detail/subscription-detail-header/subscription-detail-header";
import { ThirdPartyServiceIdsRowContentComponent } from "../../../../components/subscription-detail/third-party-service-ids-row-content/third-party-service-ids-row-content";
import { EnabledPipe } from "../../../../helpers/enabledpipe/enabledpipe";
import { ServiceSpeedPipe } from "../../../../helpers/service-speed-pipe/service-speed-pipe";
import { SubscriptionDatePipe } from "../../../../helpers/subscription-datepipe/subscription-datepipe";
import { ServicePortSubscriptionDetails } from "../../types";
import { SubscriptionViewBase } from "../subscription-view-base";
import { PortShortcutMenu } from "./components/port-shortcut-menu/port-shortcut-menu";

@Component({
  selector: "port-subscription-view",
  templateUrl: "port-subscription-view.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AliasEditorComponent,
    EnabledPipe,
    PortShortcutMenu,
    RouterModule,
    ServiceId,
    ServiceSpeedPipe,
    SubscriptionDatePipe,
    PortServicesPanel,
    SubscriptionDetailHeader,
    ThirdPartyServiceIdsRowContentComponent,
    TrafficLineChart,
    TranslatePipe,
  ],
})
export class PortSubscriptionViewComponent extends SubscriptionViewBase<ServicePortSubscriptionDetails> {
  private translate = inject(TranslateService);
  protected readonly chartSubjects = computed<TrafficSubject[]>(() => [
    makeAllServicesOption(this.subscriptionId(), this.translate),
    ...(this.subscription().services ?? []).map(makeNamedOption),
  ]);

  protected aggregateParent = computed(() => this.subscription().aggregateParent);
  protected autoNegotiation = computed(() => this.subscription().autoNegotiation);
  protected domain = computed(() => this.subscription().domain ?? "");
  protected portMode = computed(() => this.subscription().portMode);
  protected portSpeed = computed(() => this.subscription().portSpeed);
  protected address = computed(() => this.subscription().address);
  protected patchPosition = computed(() => this.subscription().patchPosition);
  protected ieeeInterfaceType = computed(() => this.subscription().ieeeInterfaceType);
  protected fiberType = computed(() => this.subscription().fiberType);
}
